import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import {useSelector} from "react-redux";
import clsx from "clsx";
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css'

import '../../../styles/resize/overrides.css';

// Carousel
import SmartCarousel from "../components/carousel/SmartCarousel";

import SmartCarouselItem from "../components/carousel/SmartCarouselItem";
// Charts
import BarChart from "../components/barchart/BarChart";

import PieChart from "../components/piechart/PieChart";
import TimeSeriesChart from "../components/timeseries/TimeSeriesChart";
import TreemapChart from "../components/treemapchart/TreemapChart";
import WordcloudChart from "../components/wordcloudchart/WordcloudChart";
import BubbleChart from "../components/bubblechart/BubbleChart";
// Tabs
import SmartTab from "../components/tabs/Tab";

import TabFilter from "../components/tabs/TabFilter";
// Drop Down
import DropDownFilter from "../components/DropDownFilter";

// File Upload
import FileDropZone from "../components/dropzone/FileDropZone";

// Lists
import SmartList from "../components/smartlist/SmartList";

import KPIGroup from "../components/performanceindicator/KPIGroup";
// Tables
import SmartTable from "../components/table/SmartTable";

// Data Grid
import SmartDataGrid from "../components/smartdatagrid/SmartDataGrid";

// Gantt
import GanttChart from "../components/gantt/Gantt";

// Scatter Chart
import ScatterChart from "../components/scatterchart/ScatterChart";

// Stone Cutter
import PortfolioStoneCutter from "../components/projectcards/PortfolioStoneCutter";

// Generic
import UnderConstruction from "../components/UnderContruction";

import BudgetDates from "../components/BudgetDates";
import Writeup from "../components/writeup/Writeup";
import MetricCard from "../components/metriccard/MetricCard";
import PerformanceIndicator from "../components/performanceindicator/PerformanceIndicator";
import KeyAttributes from "../components/keyattributes/KeyAttributes";
import TrendsInsights from "../components/trendsinsights/TrendsInsights";
import ImageCard from "../components/image/ImageCard";
import ActivityGauge from "../components/activitygauge/ActivityGauge";
import SmartDate from "../components/smartdate/SmartDate";
import EyeFrame from "../components/EyeFrame";
import PBIEmbed from "../components/PBIEmbed";
import TitleCard from "../components/TitleCard";
import CallToAction from "../components/CallToAction";
import SmartButton from "../components/SmartButton";
import SmartError from "../components/SmartError";
import SmartHeading from "../components/SmartHeading";
import SmartImage from "../components/SmartImage";
import SmartIcon from "../components/SmartIcon";
import SmartTicker from "../components/SmartTicker";
// Magic Matrix
import MagicMatrixCard from "../components/MagicMatrixCard";

// Map
import SmartMap from "../components/map/SmartMap";

// Navigation Components
import Navigation from "../components/navigation/Navigation";

import NavigationPager from "../components/navigation/NavigationPager";
import NavigationCards from "../components/navigation/NavigationCards";
// Reporting
import CreateReport from "../components/reports/CreateReport";

import ReportList from "../components/reports/ReportList";
// Data Settings Layout
import DataSettingsLayout from "../../data/DataSettingsLayout";

// Emissions Inventory (SAM) - Edit QAQC Status
import EmissionsEditQAQCStatusLayout from "../../../packages/emissions/EmissionsEditQAQCStatusLayout";

// Project Hub Setup - New Project and New Client Forms
import ProjectHubSetupProject from "../../../packages/projecthub/ProjectHubSetupProject";
import ProjectHubSetupEditProject from "../../../packages/projecthub/ProjectHubSetupEditProject";
import ProjectHubSetupClient from "../../../packages/projecthub/ProjectHubSetupClient";
import ProjectHubSetupEditClient from "../../../packages/projecthub/ProjectHubSetupEditClient";
import UserGroupLayout from "../../../packages/projecthub/usergroup/UserGroupLayout";
import ModelOrdersLayout from "../../../packages/swmm/modelorders/ModelOrdersLayout";

// Model Types
import ModelTypeGroup from "../components/modeltypeindicator/ModelTypeGroup";
import ModelTypeIndicator from "../components/modeltypeindicator/ModelTypeIndicator";

// Wrappers
import {CardWrapper} from "./wrappers/CardWrapper";

import {ComponentWrapper} from "./wrappers/ComponentWrapper";
import {PreComponentWrapper} from "./wrappers/PreComponentWrapper";
// xGrid
import {ParseGridLayout} from "./xGrid/ParseGridLayout";

import { styled, Grid } from '@mui/material';


const PREFIX = 'DynamicContainer';

const classes = {
    root: `${PREFIX}-root`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const StyledGrid = styled(Grid)((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
		height: '100%',
		width: '100%',
		backgroundColor: 'rgba(0,0,0,0)' //theme.palette.background.default
	}
}));

export default function DynamicContainerLayout({ configuration, ...props }) {

	// App State
	const isThemeLight = useSelector(state => state.persist.themeLight);
	const isEditing = useSelector(state => state.persist.isEditing);

	// console.log('DynamicContainerLayout ', configuration);

	// Component State
	const [layout, setLayout] = useState(<React.Fragment/>);
	const level = -1;   // Nested React-Grid-Layouts require draggableCancel prop to have a value that is set to the sub-nested items, so the logic for level needs to increase and decrease to match other levels

	function parseComponent(component, hideListeners, level, xGridDraggable, xIdHint, handleLoading, handleLoaded) {
		// console.log('ParseComponent->', component);
		// console.log('ParseComponent->', component.type);
		// console.log('ParseComponent xGridDraggable:', xGridDraggable);
		// console.log('ParseComponent xIdHint:', xIdHint);
		// console.log('ParseComponent Level: ', level);

		if (!component) {
			return <React.Fragment/>
		}

		if (component.type.toLowerCase() === 'card') {
			// Cards can be draggable but can also contain xGrids so the level needs bumped up to pass along a new level to the xGrid
			return <CardWrapper xId={component?.id !== undefined ? component.id : null} component={component} parseComponent={parseComponent} type={component.type} level={level+1} xGridDraggable={xGridDraggable}/>
		}
		else if (component.type.toLowerCase() === 'barchart') {
			return <ComponentWrapper component={<BarChart key={'bc{0}'.format(window.dw.utils.newID())}
														  id={'{0}-{1}'.format(component.configuration.dataSource.name.toLowerCase(), component.configuration?.xFilter.field ? component.configuration.xFilter.field.toLowerCase() : window.dw.utils.newID())}
														  configuration={component.configuration}
														  xId={component?.id !== undefined ? component.id : null}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'piechart') {
			return <ComponentWrapper component={<PieChart key={'pc{0}'.format(window.dw.utils.newID())}
														  id={'{0}-{1}'.format(component.configuration.dataSource.name.toLowerCase(), component.configuration?.xFilter.field ? component.configuration.xFilter.field.toLowerCase() : window.dw.utils.newID())}
														  configuration={component.configuration}
														  xId={component?.id !== undefined ? component.id : null}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'timeserieschart') {
			return <ComponentWrapper component={<TimeSeriesChart key={'tsc{0}'.format(window.dw.utils.newID())}
																 id={'{0}-{1}'.format(component.configuration.dataSource.name.toLowerCase(), component.configuration?.xFilter?.field ? component.configuration.xFilter.field.toLowerCase() : window.dw.utils.newID())}
																 configuration={component.configuration}
																 xId={component?.id !== undefined ? component.id : null}
																 onLoading={handleLoading}
																 onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'treemapchart') {
			return <ComponentWrapper component={<TreemapChart key={'tmc{0}'.format(window.dw.utils.newID())}
															  id={'{0}-{1}'.format(component.configuration.dataSource.name.toLowerCase(), component.configuration?.xFilter?.field ? component.configuration.xFilter.field.toLowerCase() : window.dw.utils.newID())}
															  configuration={component.configuration}
															  xId={component?.id !== undefined ? component.id : null}
															  onLoading={handleLoading}
															  onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'wordcloudchart') {
			return <ComponentWrapper component={<WordcloudChart key={'wcc{0}'.format(window.dw.utils.newID())}
																id={'{0}-{1}'.format(component.configuration.dataSource.name.toLowerCase(), component.configuration?.xFilter?.field ? component.configuration.xFilter.field.toLowerCase() : window.dw.utils.newID())}
																configuration={component.configuration}
																xId={component?.id !== undefined ? component.id : null}
																onLoading={handleLoading}
																onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'bubblechart') {
			return <ComponentWrapper component={<BubbleChart key={'bb{0}'.format(window.dw.utils.newID())}
															 id={'{0}-{1}'.format(component.configuration.dataSource.name.toLowerCase(), component.configuration?.xFilter?.field ? component.configuration.xFilter.field.toLowerCase() : window.dw.utils.newID())}
															 configuration={component.configuration}
															 xId={component?.id !== undefined ? component.id : null}
															 onLoading={handleLoading}
															 onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'gantt'){

			const config = component.configuration;
			const id = window.dw.utils.newID();
			const mainComponent = <GanttChart key={'gc{0}'.format(window.dw.utils.newID())}
											  id={'{0}-{1}'.format(config.dataSource.name.toLowerCase(), config?.xFilter?.field ? config.xFilter.field.toLowerCase() : id)}
											  configuration={config}
											  xId={component?.id !== undefined ? component.id : null}/>

			const modalConfig = { ...component.configuration }
			modalConfig.element = { ...modalConfig.element, ...component.wrapper?.modal?.overrides};
			const modalComponent = !component.wrapper?.modal?.overrides ? mainComponent : <GanttChart key={'gc{0}'.format(window.dw.utils.newID())}
																									  id={'{0}-{1}'.format(modalConfig.dataSource.name.toLowerCase(), (modalConfig?.xFilter?.field ? modalConfig.xFilter.field.toLowerCase() : id) + '-m')}
																									  configuration={modalConfig}
																									  xId={component?.id !== undefined ? component.id : null}/>;
			return <ComponentWrapper component={mainComponent}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={{
										 enabled: component.wrapper?.modal?.enabled,
										 title: component.wrapper?.modal?.title,
										 parent: component.wrapper?.modal?.parent,
										 button:component.wrapper?.modal?.button,
										 component: modalComponent
									 }}
									 tooltip={component.wrapper?.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'table'){
			return <ComponentWrapper component={<SmartTable key={'st{0}'.format(window.dw.utils.newID())}
															id={'{0}-{1}'.format(component.configuration.dataSource.name.toLowerCase(), component.configuration.dataSource.idField)}
															configuration={component.configuration}
															collapsibleFilterValue={props.collapsibleFilterValue}
															xId={component?.id !== undefined ? component.id : null}
															onLoading={handleLoading}
															onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
								     xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'datagrid') {
			return <ComponentWrapper component={<SmartDataGrid key={'sdg{0}'.format(window.dw.utils.newID())}
															   id={'{0}-{1}'.format(component.configuration.dataSource.name, component.configuration.dataSource.idField)}
															   configuration={component.configuration}
															   xId={component?.id !== undefined ? component.id : null}
															   onLoading={handleLoading}
															   onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'list'){
			return <ComponentWrapper component={<SmartList key={'sl{0}'.format(window.dw.utils.newID())}
														   id={'{0}-{1}'.format(component.configuration.dataSource.name.toLowerCase(), component.configuration?.xFilter.field ? component.configuration.xFilter.field.toLowerCase() : window.dw.utils.newID())}
														   configuration={component.configuration}
														   xId={component?.id !== undefined ? component.id : null}
														   onLoading={handleLoading}
														   onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'calltoaction'){
			return <ComponentWrapper component={<CallToAction key={'cta{0}'.format(window.dw.utils.newID())}
															  id={'{0}-{1}'.format(component.configuration.dataSource.name.toLowerCase(), component.configuration.dataSource.fields.headline)}
															  configuration={component.configuration}
															  xId={component?.id !== undefined ? component.id : null}
															  onLoading={handleLoading}
															  onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'heading'){
			return <ComponentWrapper component={<SmartHeading key={'sh{0}'.format(window.dw.utils.newID())}
															  id={'{0}-{1}'.format((component.configuration?.dataSource?.name !== undefined ? component.configuration.dataSource.name.toLowerCase() : 'heading'), (component.configuration?.dataSource?.fields?.value !== undefined ? component.configuration.dataSource.fields.value : window.dw.utils.newID()))}
															  configuration={component.configuration}
															  onLoading={handleLoading}
															  onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'image'){
			return <ComponentWrapper component={<SmartImage key={'si{0}'.format(window.dw.utils.newID())}
															id={'{0}'.format(window.dw.utils.newID())}
															containerHeight={component.wrapper.parent.height}
															configuration={component.configuration}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'carousel'){
			return <ComponentWrapper component={<SmartCarousel key={'sc{0}'.format(window.dw.utils.newID())}
															   id={'{0}-{1}'.format(component.configuration.dataSource.name.toLowerCase(), component.configuration.dataSource.fields.identifier)}
                                                               configuration={component.configuration}
															   xId={component?.id !== undefined ? component.id : null}
															   onLoading={handleLoading}
															   onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'carouselitem'){
			return <ComponentWrapper component={<SmartCarouselItem key={'sci{0}'.format(window.dw.utils.newID())}
																   id={'{0}'.format('sci')}
																   carouselItem={null}
																   configuration={null}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'button'){
			return <ComponentWrapper component={<SmartButton key={'sb{0}'.format(window.dw.utils.newID())}
															 id={'{0}-{1}'.format(component.configuration.dataSource.name.toLowerCase(), component.configuration?.dataSource?.fields?.value)}
															 configuration={component.configuration}
															 onLoading={handleLoading}
															 onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'createreport'){
			return <ComponentWrapper component={<CreateReport key={'sb{0}'.format(window.dw.utils.newID())}
															  id={'{0}-{1}'.format(component.configuration?.dataSource?.name?.toLowerCase(), component.configuration?.dataSource?.fields?.value)}
															  configuration={component.configuration}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'reportlist'){
			return <ComponentWrapper component={<ReportList key={'sb{0}'.format(window.dw.utils.newID())}
															id={'{0}-{1}'.format(component.configuration?.dataSource?.name?.toLowerCase(), component.configuration?.dataSource?.fields?.value)}
															configuration={component.configuration}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		}
		else if (component.type.toLowerCase() === 'stonecutter'){
			return <ComponentWrapper component={<PortfolioStoneCutter key={'sb{0}'.format(window.dw.utils.newID())}
																	  id={'{0}-{1}'.format(component.configuration.dataSource.name.toLowerCase(), component.configuration.dataSource.fields.value)}
																	  configuration={component.configuration}/>}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'map') {

			const config = component.configuration;
			const mainComponent = <PreComponentWrapper config={component}>
				<SmartMap key={'sm{0}'.format(window.dw.utils.newID())} configuration={config}/>
			</PreComponentWrapper>

			const modalConfig = { ...component.configuration }
			modalConfig.element = { ...modalConfig.element, ...component.wrapper?.modal?.overrides};
			const modalComponent = !component.wrapper?.modal?.overrides ? mainComponent : <PreComponentWrapper config={component}>
				<SmartMap key={'sm{0}'.format(window.dw.utils.newID())} configuration={modalConfig}/>
			</PreComponentWrapper>

			return <ComponentWrapper component={mainComponent}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper?.paper}
									 modal={{
										 enabled: component.wrapper?.modal?.enabled,
										 title: component.wrapper?.modal?.title,
										 parent: component.wrapper?.modal?.parent,
										 button:component.wrapper?.modal?.button,
										 component: modalComponent
									 }}
									 tooltip={component.wrapper?.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'underconstruction') {
			return <ComponentWrapper component={<UnderConstruction title={component.configuration?.name?.title} subtitle={component.configuration?.name?.subtitle} />}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		}  else if (component.type.toLowerCase() === 'error'){
			return <ComponentWrapper component={<SmartError key={'se{0}'.format(window.dw.utils.newID())}
															configuration={component.configuration}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'eyeframe') {
			return <ComponentWrapper component={<EyeFrame key={'ef{0}'.format(window.dw.utils.newID())}
														  configuration={component.configuration}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'powerbi') {
			return <ComponentWrapper component={<PBIEmbed key={'pbi{0}'.format(window.dw.utils.newID())}
														  configuration={component.configuration}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'navigation') {
			return <ComponentWrapper component={<Navigation selector={component.configuration.selector} details={component.configuration.details} />}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'navigationcards') {
			return <ComponentWrapper component={<NavigationCards configuration={component.configuration} />}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'navigationpager') {
			return <ComponentWrapper component={<NavigationPager configuration={component.configuration} />}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === "budgetdates") {
			return <ComponentWrapper component={<BudgetDates key={'bd{0}'.format(window.dw.utils.newID())}
															 id={'{0}-{1}'.format(component.configuration.dataSource.name, component.configuration?.xFilter.field ? component.configuration.xFilter.field.toLowerCase() : window.dw.utils.newID())}
															 configuration={component.configuration}
															 xId={component?.id !== undefined ? component.id : null}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === "writeup") {
			return <ComponentWrapper component={<Writeup key={'wu{0}'.format(window.dw.utils.newID())}
														 id={'{0}-{1}'.format(component.configuration.dataSource.name, component.configuration?.xFilter.field ? component.configuration.xFilter.field.toLowerCase() : window.dw.utils.newID())}
														 configuration={component.configuration}
														 xId={component?.id !== undefined ? component.id : null}
														 onLoading={handleLoading}
														 onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === "metriccard") {
			return <ComponentWrapper component={<MetricCard key={'mc{0}'.format(window.dw.utils.newID())}
															id={'{0}-{1}'.format(component.configuration.dataSource.name, (component.configuration.dataSource?.fields?.field?.name !== undefined ? component.configuration.dataSource.fields.field.name : window.dw.utils.newID()))}
															configuration={component.configuration}
															xId={component?.id !== undefined ? component.id : null}
															onLoading={handleLoading}
															onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === "performanceindicator") {
			return <ComponentWrapper component={<PerformanceIndicator key={'pi{0}'.format(window.dw.utils.newID())}
																	  id={'{0}-{1}'.format(component.configuration.dataSource.name, component.configuration.dataSource.fields.field.name)}
																	  configuration={component.configuration}
																	  xId={component?.id !== undefined ? component.id : null}
																	  onLoading={handleLoading}
																	  onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === "magicmatrixcard") {
			// NOTE: Matrix uses multiple datasources
			return <ComponentWrapper component={<MagicMatrixCard key={'mmc{0}'.format(window.dw.utils.newID())}
																 id={'{0}-{1}-{2}'.format(component.configuration.dataSource.positionName, component.configuration.dataSource.fields.position, component.configuration.element.position.value)}
																 configuration={component.configuration}
																 onLoading={handleLoading}
																 onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === "keyattributes") {
			return <ComponentWrapper component={<KeyAttributes key={'ka{0}'.format(window.dw.utils.newID())}
															   id={'{0}-{1}'.format(component.configuration.dataSource.name, component.configuration?.xFilter?.field ? component.configuration.xFilter.field.toLowerCase() : window.dw.utils.newID())}
															   configuration={component.configuration}
															   xId={component?.id !== undefined ? component.id : null}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === "kpigroup") {
			return <ComponentWrapper component={<KPIGroup key={'kpig{0}'.format(window.dw.utils.newID())}
														  id={'{0}-{1}'.format(component.configuration.dataSource.name, component.configuration?.xFilter?.field ? component.configuration.xFilter.field.toLowerCase() : window.dw.utils.newID())}
														  configuration={component.configuration}
														  xId={component?.id !== undefined ? component.id : null}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === "trendsinsights") {
			return <ComponentWrapper component={<TrendsInsights key={'ti{0}'.format(window.dw.utils.newID())}
																id={'{0}-{1}'.format(component.configuration.dataSource.name, window.dw.utils.newID())}
																configuration={component.configuration}
																xId={component?.id !== undefined ? component.id : null}
																onLoading={handleLoading}
																onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === "imagecard") {
			return <ComponentWrapper component={<ImageCard key={'ic{0}'.format(window.dw.utils.newID())}
														   id={'{0}-{1}'.format(component.configuration.dataSource.name, window.dw.utils.newID())}
														   configuration={component.configuration}
														   onLoading={handleLoading}
														   onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'activitygauge') {
			return <ComponentWrapper component={<ActivityGauge key={'ag{0}'.format(window.dw.utils.newID())}
															   id={'{0}-{1}'.format(component.configuration.dataSource.name, component.configuration?.xFilter.field ? component.configuration.xFilter.field.toLowerCase() : window.dw.utils.newID())}
															   configuration={component.configuration}
															   xId={component?.id !== undefined ? component.id : null}
															   onLoading={handleLoading}
															   onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'smartdate') {
			return <ComponentWrapper component={<SmartDate key={'sd{0}'.format(window.dw.utils.newID())}
														   id={'{0}-{1}'.format(component.configuration.dataSource.name, component.configuration.dataSource?.field?.name ? component.configuration.dataSource.field.name.toLowerCase() : window.dw.utils.newID())}
														   configuration={component.configuration}
														   xId={component?.id !== undefined ? component.id : null}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'titlecard') {
			return <ComponentWrapper component={<TitleCard key={'tc{0}'.format(window.dw.utils.newID())}
														   id={'{0}-{1}'.format(component.configuration.dataSource.name, window.dw.utils.newID())}
														   configuration={component.configuration}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'dropdownfilter') {
			return <ComponentWrapper component={<DropDownFilter key={'df{0}'.format(window.dw.utils.newID())}
																id={'{0}-{1}'.format(component.configuration.dataSource.name, component.configuration?.xFilter.field ? component.configuration.xFilter.field.toLowerCase() : window.dw.utils.newID())}
																configuration={component.configuration}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === "icon") {
			return (<ComponentWrapper component={<SmartIcon configuration={component.configuration} />}
									  xId={component?.id !== undefined ? component.id : null}
									  paper={component.wrapper.paper}
									  xGridDraggable={xGridDraggable}
									  xIdHint={xIdHint}>
			</ComponentWrapper>);
		} else if (component.type.toLowerCase() === "ticker") {
			return (<ComponentWrapper component={<SmartTicker configuration={component.configuration} />}
									  xId={component?.id !== undefined ? component.id : null}
									  paper={component.wrapper.paper}
									  xGridDraggable={xGridDraggable}
									  xIdHint={xIdHint}>
			</ComponentWrapper>);
		} else if (component.type.toLowerCase() === "datasettings") {
			return (<DataSettingsLayout/>);
		} else if (component.type.toLowerCase() === "phnewclient") {
			return (<ComponentWrapper component={<ProjectHubSetupClient key={'gc{0}'.format(window.dw.utils.newID())}
																	   configuration={component.configuration}
																	   xId={component?.id !== undefined ? component.id : null} />}
									  xId={component?.id !== undefined ? component.id : null}
									  paper={component.wrapper.paper}
									  xGridDraggable={xGridDraggable}
									  xIdHint={xIdHint}>
			</ComponentWrapper>);
		} else if (component.type.toLowerCase() === "phnewproject") {
			return (<ComponentWrapper component={<ProjectHubSetupProject key={'gc{0}'.format(window.dw.utils.newID())}
																		 configuration={component.configuration}
																		 xId={component?.id !== undefined ? component.id : null} />}
									  xId={component?.id !== undefined ? component.id : null}
									  paper={component.wrapper.paper}
									  xGridDraggable={xGridDraggable}
									  xIdHint={xIdHint}>
			</ComponentWrapper>);
		} else if (component.type.toLowerCase() === "pheditproject") {
			return (<ComponentWrapper component={<ProjectHubSetupEditProject key={'gc{0}'.format(window.dw.utils.newID())}
																		 configuration={component.configuration}
																		 xId={component?.id !== undefined ? component.id : null} />}
									  xId={component?.id !== undefined ? component.id : null}
									  paper={component.wrapper.paper}
									  xGridDraggable={xGridDraggable}
									  xIdHint={xIdHint}>
			</ComponentWrapper>);
		} else if (component.type.toLowerCase() === "pheditclient") {
			return (<ComponentWrapper component={<ProjectHubSetupEditClient key={'gc{0}'.format(window.dw.utils.newID())}
																			 configuration={component.configuration}
																			 xId={component?.id !== undefined ? component.id : null} />}
									  xId={component?.id !== undefined ? component.id : null}
									  paper={component.wrapper.paper}
									  xGridDraggable={xGridDraggable}
									  xIdHint={xIdHint}>
			</ComponentWrapper>);
		} else if (component.type.toLowerCase() === "phusergroup") {
			return (<ComponentWrapper component={<UserGroupLayout key={'gc{0}'.format(window.dw.utils.newID())}
																			configuration={component.configuration}
																			xId={component?.id !== undefined ? component.id : null} />}
									  xId={component?.id !== undefined ? component.id : null}
									  paper={component.wrapper.paper}
									  xGridDraggable={xGridDraggable}
									  xIdHint={xIdHint}>
			</ComponentWrapper>);
		} else if (component.type.toLowerCase() === "phmodelorder") {
			return (<ComponentWrapper component={<ModelOrdersLayout key={'gc{0}'.format(window.dw.utils.newID())}
																  configuration={component.configuration}
																  xId={component?.id !== undefined ? component.id : null} />}
									  xId={component?.id !== undefined ? component.id : null}
									  paper={component.wrapper.paper}
									  xGridDraggable={xGridDraggable}
									  xIdHint={xIdHint}>
			</ComponentWrapper>);
		} else if (component.type.toLowerCase() === "pheieditqaqcstatus") {
			return (<ComponentWrapper component={<EmissionsEditQAQCStatusLayout key={'gc{0}'.format(window.dw.utils.newID())}
																				configuration={component.configuration}
																				xId={component?.id !== undefined ? component.id : null} />}
									  xId={component?.id !== undefined ? component.id : null}
									  paper={component.wrapper.paper}
									  xGridDraggable={xGridDraggable}
									  xIdHint={xIdHint}>
			</ComponentWrapper>);
		} else if (component.type.toLowerCase() === "dropzone") {
			return (<ComponentWrapper component={<FileDropZone key={'dz{0}'.format(window.dw.utils.newID())}
															   id={'{0}-{1}'.format(component.configuration.dataSource.name, window.dw.utils.newID())}
															   configuration={component.configuration}
															   xId={component?.id !== undefined ? component.id : null}/>}
									  xId={component?.id !== undefined ? component.id : null}
									  dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									  paper={component.wrapper.paper}
									  modal={component.wrapper.modal}
									  tooltip={component.wrapper.tooltip}
									  link={component.wrapper.link}
									  flip={component.wrapper.flip}
									  parseComponent={parseComponent}
									  type={component.type}
									  xGridDraggable={xGridDraggable}
									  xIdHint={xIdHint}>
			</ComponentWrapper>);
		} else if (component.type.toLowerCase() === "scatterchart") {
				return (<ComponentWrapper component={<ScatterChart key={'dz{0}'.format(window.dw.utils.newID())}
																   id={'{0}-{1}'.format(component.configuration.dataSource.name, window.dw.utils.newID())}
																   configuration={component.configuration}
																   xId={component?.id !== undefined ? component.id : null} />}
										  xId={component?.id !== undefined ? component.id : null}
										  dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
										  paper={component.wrapper.paper}
										  modal={component.wrapper.modal}
										  tooltip={component.wrapper.tooltip}
										  link={component.wrapper.link}
										  flip={component.wrapper.flip}
										  parseComponent={parseComponent}
										  type={component.type}
										  xGridDraggable={xGridDraggable}
										  xIdHint={xIdHint}>
				</ComponentWrapper>);
		} else if (component.type.toLowerCase() === "modeltypegroup") {
			return <ComponentWrapper component={<ModelTypeGroup key={'kpig{0}'.format(window.dw.utils.newID())}
														  id={'{0}-{1}'.format(component.configuration.dataSource.name, component.configuration?.xFilter?.field ? component.configuration.xFilter.field.toLowerCase() : window.dw.utils.newID())}
														  configuration={component.configuration}
														  xId={component?.id !== undefined ? component.id : null}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === "modeltypeindicator") {
			return <ComponentWrapper component={<ModelTypeIndicator key={'pi{0}'.format(window.dw.utils.newID())}
																	  id={'{0}-{1}'.format(component.configuration.dataSource.name, component.configuration.dataSource.fields.field.name)}
																	  configuration={component.configuration}
																	  xId={component?.id !== undefined ? component.id : null}
																	  onLoading={handleLoading}
																	  onLoaded={handleLoaded}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 dataSourceName={hideListeners ? null : component.configuration?.dataSource?.name}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 tooltip={component.wrapper.tooltip}
									 link={component.wrapper.link}
									 flip={component.wrapper.flip}
									 parseComponent={parseComponent}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'xgrid') {
			return (<ParseGridLayout key={component.id} container={component} level={level} parseComponent={parseComponent} hideListeners={hideListeners} xGridDraggable={xGridDraggable} />)
		} else if (component.type.toLowerCase() === 'grid') {
			return parseGrid(component, hideListeners, level, xGridDraggable, xIdHint, handleLoading, handleLoaded);
		} else if (component.type.toLowerCase() === 'tab') {
			return <ComponentWrapper component={<SmartTab key={'tb{0}'.format(window.dw.utils.newID())}
														  configuration={component.configuration}
														  parseComponent={parseComponent}
														  level={level}
														  xId={component?.id !== undefined ? component.id : null}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else if (component.type.toLowerCase() === 'tabfilter') {
			return <ComponentWrapper component={<TabFilter key={'tf{0}'.format(window.dw.utils.newID())}
														   id={'{0}-{1}'.format(component.configuration.dataSource.name, component.configuration?.xFilter.field ? component.configuration.xFilter.field.toLowerCase() : window.dw.utils.newID())}
														   configuration={component.configuration}
														   parseComponent={parseComponent}
														   level={level}/>}
									 xId={component?.id !== undefined ? component.id : null}
									 paper={component.wrapper.paper}
									 modal={component.wrapper.modal}
									 type={component.type}
									 xGridDraggable={xGridDraggable}
									 xIdHint={xIdHint}>
			</ComponentWrapper>
		} else {
			return <div>Missing Component: {component.type}</div>
		}
	}

	// Type = Grid --> Material UI Grid
	function parseGrid(container, hideListeners, level, xGridDraggable, xIdHint, handleLoading, handleLoaded) {
		// console.log('ParseGrid->', container);
		// console.log('ParseGrid Level: ', level);

		const components = container.configuration.components;
		components.index = -1;

		const gridConfiguration = container.configuration.layout;
		const contentAlignmentConfiguration = container?.configuration?.layout?.contentAlignment !== undefined ? container.configuration.layout.contentAlignment : "flex-start";
		const contentJustificationConfiguration = container?.configuration?.layout?.contentJustification !== undefined ? container.configuration.layout.contentJustification : "center";

		let rootStyle = {};
		// Note: We cannot spread multiple position values etc. for correct
		// brower from json
		// if (container?.configuration?.element?.root) {
		// rootStyle = prefix(container?.configuration?.element?.root);
		rootStyle = container?.configuration?.element?.root;
		// }

		return <ComponentWrapper key={window.dw.utils.newID()}
				  component={<StyledGrid key={window.dw.utils.newID()} container
										 justifyContent={contentJustificationConfiguration} alignItems={contentAlignmentConfiguration}
										 className={classes.root} spacing={0} style={rootStyle}>
										{gridConfiguration.rows.map((r, i) => {
											  return (
												  <React.Fragment key={i}>
													  {
														  r.cols.map((c, j) => {
															  // console.log('row: {0} col: {1}'.format(i, j));

															  // Increment to current component position
															  components.index++;

															  const classNames = [];
															  if (c.xs === false) {
																  classNames.push("xs-hidden");
															  }
															  if (c.sm === false) {
																  classNames.push("sm-hidden");
															  }
															  if (c.md === false) {
																  classNames.push("md-hidden");
															  }
															  if (c.lg === false) {
																  classNames.push("lg-hidden");
															  }
															  if (c.xl === false) {
																  classNames.push("xl-hidden");
															  }
															  // console.log('classNames -> ', classNames.join(' '));

															  const parentStyle = components[components.index]?.wrapper?.parent;

															  // console.log('parentStyle -> ', parentStyle);

															  return (
																  <Grid className={clsx(classNames.join(' '))}
																		key={'{0}-{1}{2}'.format(window.dw.utils.newID(), i, components.index)}
																		item
																		xs={c.xs}
																		sm={c.sm} md={c.md} lg={c.lg} xl={c.xl}
																		style={{...parentStyle}}>
																	  {parseComponent(components[components.index], hideListeners, level, false, null, handleLoading, handleLoaded)}
																  </Grid>
															  );

														  })
													  }
												  </React.Fragment>
											  );
										})}
				  			</StyledGrid>}
				  paper={container?.wrapper?.paper}
				  modal={container?.wrapper?.modal}
				  type={container?.type}
				  xGridDraggable={xGridDraggable}
				  xIdHint={xIdHint}>
			</ComponentWrapper>
	}

	useEffect(() => {
		// console.log('DynamicContainerLayout: UseEffect, [configuration] ', configuration);

		setLayout(parseComponent(configuration, false, level, false, null, null, null));

	}, [configuration, isThemeLight, isEditing]);

	return (
		<React.Fragment>
			{layout}
		</React.Fragment>
	);
}
